export default "__VITE_ASSET__EdEPFWuY__"